<template>
  <el-dialog
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    class="new_dialog"
    width="597px"
    title="短视频营销助手"
  >
    <div class="flex">
      <div class="t1">短视频营销助手下载和使用说明</div>
      <div class="t2">
        飞书链接：
        <el-link :href="reactiveData.oem_client_url" target="_blank">
          {{ reactiveData.oem_client_url }}
        </el-link>
      </div>
      <div class="t3">
        密码：{{ reactiveData.oem_client_password }}
        <el-link type="primary" :underline="false" @click="copy_handle">
          复制
        </el-link>
      </div>
      <el-button type="primary" @click="emit('update:modelValue', false)">
        知道了
      </el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { toRefs, reactive, watchEffect } from 'vue'
import { copyText } from 'vue3-clipboard'
import { ElMessage } from 'element-plus'
import { get_oem } from '@/utils/api'

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const reactiveData = reactive({
  oem_client_url: '',
  oem_client_password: '',
})

watchEffect((onInvalidate) => {
  if (modelValue.value) {
    const controller = new AbortController()
    get_oem({}, { signal: controller.signal }).then(({ data: res }) => {
      Object.assign(reactiveData, res.data)
    })
    onInvalidate(() => {
      controller.abort()
    })
  }
})

const copy_handle = (event) => {
  copyText(reactiveData.oem_client_password, undefined, (error, event) => {
    if (error) {
      ElMessage.error('复制失败')
    } else {
      ElMessage.success('复制成功')
    }
  })
}
</script>

<style lang="scss" scoped>
.flex {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .t1 {
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: bold;
  }
  .t2 {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
  }
  .t3 {
    margin-bottom: 57px;
    height: 55px;
    background: #0b1830;
    border-radius: 7px;
    border: 1px solid #354d7c;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
    .el-link {
      margin-left: 16px;
    }
  }
  .el-button {
    width: 145px;
  }
}
</style>
